"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chinaTranslations = void 0;
var _types = require("../../../types");
const chinaTranslations = exports.chinaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: '非常抱歉！',
  [_types.ErrorPageTranslationKey.buttonText]: '返回',
  [_types.ErrorPageTranslationKey.text]: '当前页面出现故障。',
  [_types.ErrorPageTranslationKey.notFound]: '您点击的页面暂时无法打开',
  [_types.ErrorPageTranslationKey.unauthorized]: '您访问的页面受到限制，请点击此处返回主页面。',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: '请通过电子邮件联系欧瑞莲支持团队：',
  [_types.ErrorPageTranslationKey.rejectedUrl]: '请求的 URL 被拒绝！'
};
